import {
    Injectable,
    EmbeddedViewRef,
    ComponentFactoryResolver,
    Injector,
    ApplicationRef
  } from '@angular/core';
import { ProductSNSModalALComponent } from './product-sns-modal-al.component';
import { IDataConfig } from 'abs-ngx-library/src/lib/core';
import { BehaviorSubject } from 'rxjs';
declare let $: any;

@Injectable()

export class ProductSNSModalALService {
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector
    ) {}

    public frequencySelected = new BehaviorSubject<any>(null);
    public errorModalSnsInfo = new BehaviorSubject<any>(null);

    show(dataConfig: IDataConfig) {

        // create a component reference from the component
        const component = this.componentFactoryResolver
        .resolveComponentFactory(ProductSNSModalALComponent)
        .create(this.injector);
        component.instance.dataConfig = dataConfig;

        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(component.hostView);
        component.instance.closeModalEvent.subscribe(val => {
            if( !!dataConfig && 
                dataConfig.hasOwnProperty('modal') && 
                dataConfig.modal === 'errorModal' &&  dataConfig.selectedFrequency
            ) {
                this.errorModalSnsInfo.next({
                    isChecked: dataConfig.errModalType !== 'subscribe', 
                    selectedFrequency:  dataConfig.selectedFrequency 
                });
            }
            this.appRef.detachView(component.hostView);
            $('product-sns-modal-al').siblings(':not(script, style, #contactUsModal)').removeAttr('aria-hidden'); 
            const prevElement = $('#' + dataConfig.prevIdToFocus);
            if(prevElement && prevElement.length){
                setTimeout(() => prevElement.focus(),0);
            }
            component.destroy();
        });

        // Get DOM element from component
        const domElem = (component.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;

        // Append DOM element to the body
        document.body.appendChild(domElem);
        // Put focus inside the modal
        setTimeout(() => $('.sns-modal__close-btn').focus(),0);
        $('product-sns-modal-al').siblings(':not(script, style, #contactUsModal)').attr('aria-hidden', 'true');    
    }

    emitFrequency(frequency){
        this.frequencySelected.next(frequency);
    }

    public getDynamicContents() {
        const selector = 'sns-dynamic-data-content';
        const elemRef = document.getElementsByClassName(selector);
        if (elemRef?.length > 0) {
            const contents = elemRef[0].getAttribute('data-prop-sns');
            return contents ? JSON.parse(contents) : {};
        }
        return {};
    }
}